module.exports = __webpack_public_path__ + "img/download_bg@2x.b834be75.png";